import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Planning\FetchEventPlanningController::__invoke
* @see app/Http/Controllers/Planning/FetchEventPlanningController.php
* @route '/api/planning/fetch-events'
*/
const FetchEventPlanningController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchEventPlanningController.url(options),
    method: 'post',
})

FetchEventPlanningController.definition = {
    methods: ["post"],
    url: '/api/planning/fetch-events',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Planning\FetchEventPlanningController::__invoke
* @see app/Http/Controllers/Planning/FetchEventPlanningController.php
* @route '/api/planning/fetch-events'
*/
FetchEventPlanningController.url = (options?: RouteQueryOptions) => {
    return FetchEventPlanningController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Planning\FetchEventPlanningController::__invoke
* @see app/Http/Controllers/Planning/FetchEventPlanningController.php
* @route '/api/planning/fetch-events'
*/
FetchEventPlanningController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchEventPlanningController.url(options),
    method: 'post',
})

export default FetchEventPlanningController